module.exports = __webpack_public_path__ + "img/apexTag.1d95fe5b.png";